import React, { Component } from 'react';
import { NEET_HELP_EMAIL } from './helper/Constants';

class rtoAppPrivacy extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="wrapper">
          <header className="header">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-auto">
                  <div className="logo">
                    <a href="index.html">
                      <img src="/assets/images/logo.png" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div className="container">
            <div className="whiteBox privacyPolicy">
              <div className="titleRow">
                <h1 className="title">Privacy Policy</h1>
              </div>

              <div className="textContent">
                <div className="desc">
                  <p>
                    RTO Vehicle Info app is a commercial app by Girnar Care
                    Private Limited. This document outlines how we handle the
                    collection, use, and disclosure of personal information when
                    you use the RTO app. By using RTO app, you consent to the
                    terms of our privacy policy ("Privacy Policy") in addition
                    to our Terms of Service. We encourage you to review this
                    Privacy Policy periodically to stay informed about any
                    updates or changes we make.
                  </p>
                </div>
                <h2>Personal Identification Information</h2>
                <div className="desc">
                  <p>
                    When you use our service, you consent to the collection and
                    use of personal identification information outlined in this
                    policy.This information is utilized to enhance and
                    personalize the service we provide. We do not share your
                    information with any third parties except as described in
                    this Privacy Policy.
                  </p>
                  <p>
                    The personal information you provide on the RTO app, such as
                    your name, address will be displayed on your private
                    profile.
                  </p>
                </div>
                <h2>Information Collection</h2>
                <div className="desc">
                  <p>
                    To effectively provide and introduce any new Services to
                    you, we collect and use certain information, including, but
                    not limited to, such as:
                  </p>
                  <p>
                    <strong>Identity information:</strong> such as your Name
                  </p>
                  <p>
                    <strong>Contact information:</strong> such as your mobile
                    number
                  </p>
                  <p>
                    <strong>Usage information:</strong> Data on how you use the
                    service and interact with us.
                  </p>
                  <div className="desc">
                    <p>
                      We are committed to be transparent about the data we
                      collect about you, how it is used.
                    </p>
                    <p>
                      To effectively provide and introduce any new Services to
                      you, we collect and use certain information, including,
                      but not limited to, such as:
                    </p>
                  </div>
                </div>
                <h2>How we protect your information?</h2>
                <div className="desc">
                  <p>
                    Our privacy policy ensures the implementation of suitable
                    data collection, storage, and processing practices along
                    with robust security measures. These measures are in place
                    to safeguard your personal information and any data stored
                    within our application from unauthorized access, alteration,
                    disclosure, or destruction. All data is securely stored on
                    our server located at https://rtoadmin.girnarcare.com.
                  </p>
                </div>
                <h2>Sharing your personal information</h2>
                <div className="desc">
                  <p>
                    We do not sell, trade, or rent users personal identification
                    information to any third party. The app does use third-party
                    services that may collect information used to identify you.
                  </p>
                </div>
                <div className="desc">
                  <p>
                    Link to privacy policy of third-party service providers used
                    by the app
                  </p>
                  <p>
                    <a href="https://policies.google.com/privacy">
                      Google Play Services
                    </a>
                    <br />
                    <a href="https://policies.google.com/privacy">Firebase</a>
                  </p>
                  <p>
                    We do not disclose, transfer or share your personal
                    information with others.
                  </p>
                </div>
                <h2>Cookies</h2>
                <div className="desc">
                  <p>
                    Cookies are small files containing a modest amount of data,
                    typically utilized as anonymous and unique identifiers. They
                    are sent to your browser from the websites you visit and
                    stored in your device's internal memory.
                  </p>
                  <p>
                    Our Service does not explicitly employ these "cookies."
                    However, the application may incorporate third-party code
                    and libraries that utilize "cookies" to gather information
                    and enhance their services. You have the choice to accept or
                    decline these cookies and can be informed when a cookie is
                    being sent to your device. Declining our cookies may limit
                    your access to certain portions of this Service.
                  </p>
                </div>
                <h2>Security</h2>
                <div className="desc">
                  <p>
                    Your trust in providing us with your Personal Information is
                    highly valued, and we are committed to employing
                    commercially acceptable methods to safeguard it. It's
                    important to note, however, that no method of transmission
                    over the internet or electronic storage is entirely secure
                    and reliable, and therefore, we cannot ensure its absolute
                    security.
                  </p>
                </div>
                <h2>Links to Other Sites</h2>
                <div className="desc">
                  <p>
                    This Service may include links to other websites. Clicking
                    on a third-party link will redirect you to that respective
                    site. Please be aware that these external sites are not
                    under our operation. Hence, we strongly recommend reviewing
                    the Privacy Policy of these websites. We do not exert
                    control over, nor do we assume responsibility for the
                    content, privacy policies, or practices of any third-party
                    sites or services.
                  </p>
                </div>
                <h2>Changes to This Privacy Policy</h2>
                <div className="desc">
                  <p>
                    Our Privacy Policy may undergo occasional updates. We
                    recommend checking this page periodically for any changes.
                    Any revisions will be communicated by posting the updated
                    Privacy Policy on this page. These changes are effective
                    immediately upon posting.
                  </p>
                </div>
                <h2>Contact Us</h2>
                <div className="desc">
                  <p>
                    If you have any questions or suggestions about our Privacy
                    Policy, do not hesitate to contact us at:
                  </p>
                  <p>
                    6th Floor, Jtm Mall, opposite Jagatpura Road, Model Town,
                    Jagatpura, Jaipur, Rajasthan 302017
                  </p>
                  <p>
                    Email:{' '}
                    <a href={'mailto:' + NEET_HELP_EMAIL}>{NEET_HELP_EMAIL}</a>
                  </p>
                  <p>Thank you for using the RTO app.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default rtoAppPrivacy;
